export default __webpack_public_path__ + "static/media/facebookLogo.34990401.png";